import GenericScreen from "../../../GenericScreen";
import AdjustIcon from "@mui/icons-material/Adjust";

import GenericPhoneScreen from "../../../GenericPhoneScreen";
import imgScreen from "../../../../../../Assets/StoryPassenger/PHONE_9.png";

import connectWithDispatch from "../../../../../../Hooks/connectWithDispatch";

interface ScreenProps {
  transition: number;
}

const Screen = (props: ScreenProps) => {
  const { transition } = props;

  return (
    <GenericScreen
      showComponent={transition >= 4}
      showContent={true}
      icon={<AdjustIcon sx={styles.icon} />}
      title={"Targeted Offers"}
      text={"Looks like Mum is getting a free upgrade as well. This is great."}
      panelRight={<GenericPhoneScreen imgScreen={imgScreen} top={"36.1vh"} width={"33.9vh"} height={"5.7vh"} left={"3.35vh"} />}
    />
  );
};

const styles = {
  icon: {
    fontSize: "5.2083em",
    color: "#00B28F",
  },
};

const mapStateToProps = (state: StateType) => {
  return {
    transition: state.appReducer.story.transition,
  };
};

export default connectWithDispatch(Screen, mapStateToProps);
